import { render } from "./MyApps.vue?vue&type=template&id=61f1a80c"
import script from "./MyApps.vue?vue&type=script&lang=js"
export * from "./MyApps.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__